export const SET_THEME = "SET_THEME";
//user
export const LOGGED_IN_STATE = "LOGGED_IN_STATE";
export const LOGGED_OUT_STATE = "LOGGED_OUT_STATE";
//error
export const ON_ERROR = "ON_ERROR";